export default "__VITE_ASSET__BXfAWXko__";